import React, { useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { inventoryApi, fmtQty } from './inventoryApi';

const COPY = {
  entrada: { title: 'Entrada de mercancía', qty: 'Cantidad recibida', btn: 'Registrar entrada', color: 'bg-emerald-600 hover:bg-emerald-700' },
  ajuste: { title: 'Ajuste por conteo físico', qty: 'Existencia contada', btn: 'Guardar conteo', color: 'bg-blue-600 hover:bg-blue-700' },
  merma: { title: 'Registrar merma', qty: 'Cantidad perdida', btn: 'Registrar merma', color: 'bg-red-600 hover:bg-red-700' },
};

export const MovementDialog = ({ item, type, onClose, onSaved }) => {
  const c = COPY[type];
  const [qty, setQty] = useState('');
  const [unitCost, setUnitCost] = useState(type === 'entrada' ? String(item.cost_per_unit || '') : '');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const needsReason = type !== 'entrada';
  const preview = type === 'ajuste' ? Number(qty) - item.stock : type === 'merma' ? -Number(qty) : Number(qty);

  const save = async () => {
    if (qty === '' || Number.isNaN(Number(qty))) return toast.error('Ingresa una cantidad válida');
    if (needsReason && !reason.trim()) return toast.error('El motivo es obligatorio');
    setSaving(true);
    try {
      await inventoryApi.addMovement(item.id, {
        type,
        quantity: Number(qty),
        unit_cost: type === 'entrada' && unitCost !== '' ? Number(unitCost) : null,
        reason: reason.trim() || null,
      });
      toast.success(`${c.title}: ${item.name}`);
      onSaved();
      onClose();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  const field = 'mt-1 bg-black/50 border-gray-700 text-white';
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-gray-900 border-gray-700 text-white" data-testid="movement-dialog">
        <DialogHeader>
          <DialogTitle>{c.title}</DialogTitle>
          <DialogDescription className="text-gray-400">{item.name} · Existencia actual: <b className="text-white">{fmtQty(item.stock)} {item.unit}</b></DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className={type === 'entrada' ? '' : 'col-span-2'}>
            <Label className="text-gray-300">{c.qty} ({item.unit})</Label>
            <Input autoFocus type="number" step="any" value={qty} onChange={(e) => setQty(e.target.value)} className={field} data-testid="movement-qty" />
          </div>
          {type === 'entrada' && (
            <div>
              <Label className="text-gray-300">Costo por {item.unit} ($)</Label>
              <Input type="number" step="any" value={unitCost} onChange={(e) => setUnitCost(e.target.value)} className={field} data-testid="movement-unit-cost" />
            </div>
          )}
          <div className="col-span-2">
            <Label className="text-gray-300">Motivo {needsReason ? '*' : '(opcional)'}</Label>
            <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder={type === 'entrada' ? 'Proveedor / factura' : type === 'merma' ? 'Se quemó, caducó, se cayó...' : 'Conteo de cierre'} className={field} data-testid="movement-reason" />
          </div>
        </div>
        {qty !== '' && !Number.isNaN(Number(qty)) && (
          <p className="text-sm text-gray-400" data-testid="movement-preview">
            Movimiento: <b className={preview >= 0 ? 'text-emerald-300' : 'text-red-300'}>{preview >= 0 ? '+' : ''}{fmtQty(preview)} {item.unit}</b>
            {' '}→ Nueva existencia: <b className="text-white">{fmtQty(item.stock + preview)} {item.unit}</b>
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-gray-600 text-gray-300">Cancelar</Button>
          <Button onClick={save} disabled={saving} className={c.color} data-testid="movement-save">{saving ? 'Guardando...' : c.btn}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
